import { BAOCustomElement } from '@bao/custom-element'
import { sectionRenderer } from '@bao/section-rendering'
import { getElement } from '@bao/utils'

class QuickAdd extends BAOCustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.siteDrawers = getElement('site-drawers')
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(document, 'click', this.handleTrigger.bind(this))
  }

  async handleTrigger (event) {
    try {
      const target = event.target
      const trigger = target.closest('[data-quick-add-external-el="trigger"]')

      if (!trigger || trigger.getAttribute('aria-busy') === 'true') return

      trigger.setAttribute('aria-busy', true)

      const productUrl = trigger.dataset.productUrl

      const response = await sectionRenderer.fetchSingle(
        'quick-add',
        productUrl,
      )

      const newDOM = sectionRenderer.convertToDOM(response)
      const bodyContent = newDOM.querySelector('.sec-QuickAdd')

      /* Update view button with page and original product URL for scroll position */
      const viewButton = bodyContent.querySelector(
        '[data-quick-add-el="view"]',
      )
      const scrollPositionListEl = target.closest('[data-page]')

      if (viewButton && scrollPositionListEl) {
        const page = scrollPositionListEl.dataset.page
        const originalProductUrl =
          trigger.dataset.originalProductUrl || productUrl

        viewButton.dataset.page = page
        viewButton.dataset.originalProductUrl = originalProductUrl
      }

      this.els.body.element.innerHTML = bodyContent.outerHTML

      /* Update drawer title */
      const available = bodyContent.dataset.available === 'true'

      this.els.title.element.innerText = available
        ? this.dataset.title
        : this.dataset.notifyMeTitle

      trigger.setAttribute('aria-busy', false)
      this.siteDrawers.open('quick-add')
    } catch (error) {
      this.siteDrawers.close()
      console.error('Failed to load quick add', error)
    }
  }
}

if (!customElements.get('quick-add')) {
  customElements.define('quick-add', QuickAdd)
}
